<template>
    <!-- 超级赠礼 -->
<collapse-transition>
    <div class="goodgift" v-show="vtype>0" id="goodgift" 
        :class="{'htype1':vtype==1,'htype2':vtype==2,'htype3':vtype==3}"
    >
        <div class="spad">
            <div v-if="vtype==3"  class="disbord">
                <template v-if="vtype==3">
                    <div class="discont flex_layout flex_x_spacebetween flex_y_center">
                        <div class="dis1 flex_layout flex_y_center">
                            <div class="icon">
                                <img :src="display_info.icon">
                            </div>
                            <div class="cont flexitem_flexshrink_0">
                                <p class="p1" v-html="formatHtmlYerrowTtitle(display_info.title)"></p>
                                <p class="p2">{{display_info.sub_title}}</p>
                            </div>
                        </div>
                        
                        <div class="dis2 flex_layout flex_y_center">
                            <div v-if="formatHtmlPriceText(display_info.price_text)" class="price" v-html="formatHtmlPriceText(display_info.price_text)"></div>
                            <div class="btn flex_layout flex_xy_center">
                                <span @click="clickBtn">{{display_info.button_text}}</span>
                                <i v-if="display_info.bubble_text" class="flex_layout flex_xy_center">
                                    <span class="font18_2">{{display_info.bubble_text}}</span>
                                </i>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div v-if="vtype==1 || vtype==2" class="bord" :class="{'big_bord':vtype==2}">
                <p class="title">{{gift_title}}</p>
                <!-- 1/2 个 -->
                <template v-if="vtype==1">
                    <div class="list flex_layout">
                        <div class="listitem flex_layout" v-for="(item, index) in gift_list" :key="index">
                            <div class="limg flexitem_flexshrink_0">
                                <img :src="item.image">
                            </div>
                            <div class="rinfo flex_layout flex_flexDirection_column flex_x_spacebetween">
                                <div class="w160 flex_layout flex_y_start"><span class="font22">{{item.name}}</span></div>
                                <div class="w160 flex_layout flex_y_end"><span class="font18">{{item.desc}}</span></div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- 多个 -->
                <template v-if="vtype==2">
                    <div class="list flex_layout pd12" v-on:touchmove.stop="()=>{}">
                        <div class="listitemmore flexitem_flexshrink_0 flex_layout flex_flexDirection_column flex_x_spacebetween flex_y_center" v-for="(item, index) in gift_list" :key="index">
                            <div class="timg">
                                <img :src="item.image">
                            </div>
                            <div class="binfo flex_layout flex_flexDirection_column flex_x_spacebetween">
                                <div class="w120 flex_layout flex_y_start flex_x_center">
                                    <span class="font22 ct">{{item.name | formatItemname}}</span>
                                </div>
                                <div class="w120 flex_layout flex_y_end flex_x_center">
                                    <span class="font18 cb">{{item.desc}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="flexitem_flexshrink_0 item_position"></div>
                    </div>
                </template>
            </div> 
        </div>
    </div>
</collapse-transition>
</template>
<script>
    import slide from "../../../assets/animation/slide";
    import {
        ua,
        getDeepVal,
        fenToYuan,
    } from '@kkmh/utils'
    import CollapseTransition from '../js/collapse-transition';
    import {doTrackPvYingxiao,doTrackClick} from "../js/track";
    export default {
        components: {
            'collapse-transition': CollapseTransition
        },
        name: 'GoodsGift',
            data () {
            return {
            }
        },
        props: {
            h_data_good:{
                type: Array,
                default () {
                    return []
                }
            },
            h_data_goodinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
            j_req:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        computed: {
            vtype() {
                let display_type = getDeepVal(this.h_data_goodinfo,'display_info.type',0);
                let award_len = getDeepVal(this.h_data_goodinfo,'award_info.award_list',[]).length;
                let vtype = 0;
                if (award_len > 0) {
                    vtype = 1;
                    if (award_len > 2) {
                        vtype = 2;
                    }
                }
                if (display_type == 2) {
                    vtype = 3;
                }
                if (vtype > 0) {
                    doTrackPvYingxiao(this.j_req, this.h_data_goodinfo.display_info);
                }
                return vtype;
            },
            gift_title() {
                return getDeepVal(this.h_data_goodinfo,'award_info.title','超级赠礼');
            },
            gift_list() {
                return getDeepVal(this.h_data_goodinfo,'award_info.award_list',[]);
            },
            display_info() {
                return getDeepVal(this.h_data_goodinfo,'display_info',{});
            },
        },
        methods:{
            clickBtn(){
                let good = {};
                this.h_data_good.forEach((item, index) => {
                    if (getDeepVal(this.h_data_goodinfo,'display_info.action_good_id',0) == item.id) {
                        good = item;
                        doTrackClick(item.title, this.j_req, this.h_data_goodinfo.display_info);
                        this.$emit('clickMarketBtn', good);
                    }
                })
            },
            formatHtmlYerrowTtitle(word) {
                if (!word) 
                return '';

                let ary = word.toString().split('#');
                if(ary.length==3) {
                    return ary[0]+'<span style="color:#FF4F00;">'+ary[1]+'</span>'+ary[2];
                }

                return ary.join('');
            },
            formatHtmlPriceText(word) {
                if(!/PRICE_GAP/.test(word)) {
                    return word;
                }
                let gapprice = 0;
                this.h_data_good.forEach((item, index) => {
                    if (getDeepVal(this.h_data_goodinfo,'display_info.action_good_id',0) == item.id) {
                        // 此字段仅在 目标套餐价格（券后价）>当前选中的套餐 时生效，否则此字段不展示
                        gapprice = item.curprice - this.h_data_goodinfo.curprice;
                    }
                })
                if (gapprice > 0) {
                    return word.replace(/PRICE_GAP/, fenToYuan(gapprice));    
                } 
                return '';
            }
        },
        filters: {
            formatItemname: function(val) {
                if (val) {
                    return val.substring(0,6)    
                } else {
                    return val;
                }
                
            }
        },
    }
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.font22{
    font-size:vws(24px);
    line-height:vws(30px);
    transform:scale(.92);
    display:inline-block;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 0.6);
    transform-origin:left top;
    white-space: nowrap;
}
.font18{
    font-size:vws(24px);
    line-height:vws(24px);
    transform:scale(.75);
    display:inline-block;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transform-origin:left bottom;
    color: rgba(51, 51, 51, 0.6);
}
.font18_2{
    font-size:vws(24px);
    line-height:vws(24px);
    transform:scale(.75);
    display:inline-block;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    transform-origin:center center;
    white-space: nowrap;
}
.ct{
    transform-origin:center top;
}
.cb{
    transform-origin:center bottom;
}
.pd12{
    padding:0 vws(12px) 50px vws(12px);
    overflow-x:scroll;
    -webkit-overflow-scrolling: touch;
}
.spad{
    padding:vws(37px) vws(16px) 0;
}

.htype1{height:vws(198px) !important;}
.htype2{height:vws(266px) !important;}
.htype3{height:vws(174px) !important;}

.big_bord{
    height: vws(228px);
    overflow-y: hidden;
}
.goodgift{
    transition:0.15s height cubic-bezier(0.2, 0.8, 0.2, 1);
    .disbord{
        padding:vws(26px) vws(24px);
        background: #F9F6FF;
        border-radius: vws(12px);
        .discont{
            .dis1{
                border:0px solid;
                flex: 1;
                width: 0;
                .icon{
                    width:vws(80px);
                    height:vws(80px);
                    margin-right:vws(20px);    
                }
                .contw1{
                    width:vws(440px) !important;
                }
                .cont{
                    border:0px solid;
                    flex: 1;
                    width: 0;
                    .p1{
                        overflow:hidden;    
                        font-size:vws(26px);
                        font-weight: bold;
                        color: #333333;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .p2{
                        overflow:hidden;
                        font-size:vws(24px);
                        line-height:vws(24px);
                        font-weight: 400;
                        color: #666666;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
            .dis2{
                border:0px solid;
                .price{
                    overflow:hidden;
                    font-size:vws(24px);
                    font-weight: bold;
                    color: #FF4F00;
                    white-space: nowrap;
                    margin:0 vws(8px);
                    text-overflow: ellipsis;
                }
                .btn{
                    position:relative;
                    padding:vws(32px);
                    height: vws(56px);
                    background: #FFFFFF;
                    border-radius: vws(30px);
                    span{
                        font-size:vws(24px);
                        font-weight: bold;
                        color: #5B29F4;
                        white-space: nowrap;
                    }
                    i{
                        position:absolute;
                        right:0;
                        top:vws(-20px);
                        padding:0 vws(6px);
                        height: vws(28px);
                        overflow:hidden;
                        background: #FF4F00;
                        border-radius: vws(15px) vws(15px) vws(15px) vws(4px);
                        span{
                            color:#fff;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
    .bord{
        padding:vws(16px) 0 vws(16px) vws(16px);
        background: #F9F6FF;
        border-radius: vws(12px);
        .title{
            padding-bottom:vws(16px);
            font-size: vws(24px);
            line-height: vws(24px);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #333333;
        }
        .list{
            .listitem{
                margin-right:vws(16px);
                .limg{
                    width:vws(88px);
                    height:vws(88px);
                    overflow:hidden;
                }
                .rinfo{
                    padding:vws(14px) 0 vws(14px) vws(16px); 
                    .w160{
                        white-space: nowrap;
                        overflow: hidden;
                        width: vws(135px);
                    }
                }
            } 
            .listitemmore{
                margin-right:vws(16px);
                .timg{
                    width:vws(88px);
                    height:vws(88px);
                    overflow:hidden;
                }
                .binfo{
                    padding-top:vws(14px); 
                    .w120{
                        white-space: nowrap;overflow: hidden;width: vws(136px);
                    }
                }
            }
            .item_position{
                width:vws(16px);
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/GoodGift.vue